import { Form, Table } from 'antd'
import React, { Component } from 'react'
import './statisticsTable.scss'
import downloadPDF from './downloadPDF'
export class PaintStatisticsTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
    this.moreThanTwentyPagesRef = []
    this.lessThanTwentyPagesRef = {}
  }
  async componentDidMount() {
    //计算超长换行问题，超过17个字符就换行，正常不换行18条数据一页
    let dataList = this.props.dataList;
    //总页码，分好页的数组，每一页得数据，分页判断值，需要换行的字段，每一页不够18行需要补的行数
    let PageCount = 1, GroupByPage = [], eachPage = [], pagingJudgmentValue = 0, wrapName;
    for (let i = 0; i < dataList.length; i++) {
      if (this.props.showKey === '1') {
        wrapName = dataList[i].APPLY_HOSPITAL_NAME.length
        let rowsNum = parseInt(wrapName / 17)//计算字段超长需要换的行数
        let remainder = wrapName % 17;//如果存在余数需要加一行
        rowsNum = remainder > 0 ? rowsNum + 1 : rowsNum;
        pagingJudgmentValue += rowsNum
        if (pagingJudgmentValue <= 18) {
          eachPage.push(dataList[i])
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        } else {
          GroupByPage.push(eachPage);
          PageCount += 1;//超过18行放下一页
          eachPage = [dataList[i]];
          pagingJudgmentValue = rowsNum
          //如果数据已经循环完毕
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        }
      } else if (this.props.showKey === '2') {
        if (dataList[i].CONSULTATION_HOSPITAL_NAME && dataList[i].CONSULTATION_HOSPITAL_NAME.trim() !== ''){
          wrapName = dataList[i].CONSULTATION_HOSPITAL_NAME.length
        }else{
          wrapName=0
        }
        let rowsNum = parseInt(wrapName / 17)//计算字段超长需要换的行数
        let remainder = wrapName % 17;//如果存在余数需要加一行
        rowsNum = remainder > 0 ? rowsNum + 1 : rowsNum;
        pagingJudgmentValue += rowsNum
        if (pagingJudgmentValue <= 18) {
          eachPage.push(dataList[i])
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        } else {
          GroupByPage.push(eachPage);
          PageCount += 1;//超过18行放下一页
          eachPage = [dataList[i]];
          pagingJudgmentValue = rowsNum
          //如果数据已经循环完毕
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        }
      } else {
        wrapName = dataList[i].BILLING_DOCTOR.length
        if (!this.props.billHospitalCode && this.props.billHospitalCode.trim() !== '') {
          wrapName = dataList[i].APPLY_HOSPITAL_NAME.length
        }
        let rowsNum = parseInt(wrapName / 17)//计算字段超长需要换的行数
        let remainder = wrapName % 17;//如果存在余数需要加一行
        rowsNum = remainder > 0 ? rowsNum + 1 : rowsNum;
        pagingJudgmentValue += rowsNum
        if (pagingJudgmentValue <= 18) {
          eachPage.push(dataList[i])
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        } else {
          GroupByPage.push(eachPage);
          PageCount += 1;//超过18行放下一页
          eachPage = [dataList[i]];
          pagingJudgmentValue = rowsNum
          //如果数据已经循环完毕
          if (i + 1 === dataList.length) {
            GroupByPage.push(eachPage)//最后一页不满18行需要push
          }
        }
      }
    }
    this.setState({
      PageCount,
      GroupByPage,
    }, async () => {
      if(PageCount>20){
        await downloadPDF(this.moreThanTwentyPagesRef, 0);
        this.props.closeModal()
      }else{
        await downloadPDF(this.lessThanTwentyPagesRef, 1);
        this.props.closeModal()
      }
    })
  }
  render() {
    const { GroupByPage,  } = this.state
    console.log()
    const columns = [
      {
        title: '',
        children: [
          {
            title: this.props.applyHospitalName ? '月份' : '申请机构名称',
            dataIndex: 'APPLY_HOSPITAL_NAME',
            key: 'APPLY_HOSPITAL_NAME',
            align: this.props.applyHospitalName ? 'center' : 'left',
            width: 260,
          }
        ]
      },
      {
        title: '申请病例量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTER_APPLY',
            key: 'HOLTER_APPLY',
            align: 'center',
          },
          {
            title: '动态血压',
            dataIndex: 'BP_APPLY',
            key: 'BP_APPLY',
            align: 'center',
          },
          {
            title: '静息心电',
            dataIndex: 'ECG_APPLY',
            key: 'ECG_APPLY',
            align: 'center',
          },
          {
            title: '合计',
            dataIndex: 'APPLY_TOTAL',
            key: 'APPLY_TOTAL',
            align: 'center',
          },
        ]
      },
      {
        title: '会诊病例量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTER_Consulation_Sum',
            key: 'HOLTER_Consulation_Sum',
            align: 'center',
          },
          {
            title: '动态血压',
            dataIndex: 'BP_Consulation_Sum',
            key: 'BP_Consulation_Sum',
            align: 'center',
          },
          {
            title: '静息心电',
            dataIndex: 'ECG_Consulation_Sum',
            key: 'ECG_Consulation_Sum',
            align: 'center',
          },
          {
            title: '合计',
            dataIndex: 'Consulation_Total',
            key: 'Consulation_Total',
            align: 'center',
          },
        ]
      },
      {
        title: '退回病例量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTER_Exit_Sum',
            key: 'HOLTER_Exit_Sum',
            align: 'center',
          },
          {
            title: '动态血压',
            dataIndex: 'BP_Exit_Sum',
            key: 'BP_Exit_Sum',
            align: 'center',
          },
          {
            title: '静息心电',
            dataIndex: 'ECG_Exit_Sum',
            key: 'ECG_Exit_Sum',
            align: 'center',
          },
          {
            title: '合计',
            dataIndex: 'Exit_Total',
            key: 'Exit_Total',
            align: 'center',
          },
        ]
      },
    ]
    const doctorColumns = [
      {
        title: '',
        ellipsis: true,
        children: [
          {
            title: '会诊机构',
            dataIndex: 'CONSULTATION_HOSPITAL_NAME',
            key: 'CONSULTATION_HOSPITAL_NAME',
            ellipsis: true,
            width: this.props.consultHospitalName ? 0 : 260,
            align: 'center'
          }
        ]
      },
      {
        title: '',
        ellipsis: true,
        children: [
          {
            title: this.props.selectdoctorName ? '月份' : '姓名',
            dataIndex: 'CONSULTATION_DOCTOR_NAME',
            key: 'CONSULTATION_DOCTOR_NAME',
            ellipsis: true,
            align: 'center'
          }
        ]
      },
      {
        title: '病例会诊量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTER_Consulation_Sum',
            key: 'HOLTER_Consulation_Sum',
            align: 'center'
          },
          {
            title: '动态血压',
            dataIndex: 'BP_Consulation_Sum',
            key: 'BP_Consulation_Sum',
            align: 'center'
          },
          {
            title: '静息心电',
            dataIndex: 'ECG_Consulation_Sum',
            key: 'ECG_Consulation_Sum',
            align: 'center'
          },
          {
            title: '合计',
            dataIndex: 'Consulation_Total',
            key: 'Consulation_Total',
            align: 'center'
          },
        ]
      },
      {
        title: '病例退回量',
        children: [
          {
            title: '动态心电',
            dataIndex: 'HOLTER_Exit_Sum',
            key: 'HOLTER_Exit_Sum',
            align: 'center'
          },
          {
            title: '动态血压',
            dataIndex: 'BP_Exit_Sum',
            key: 'BP_Exit_Sum',
            align: 'center'
          },
          {
            title: '静息心电',
            dataIndex: 'ECG_Exit_Sum',
            key: 'ECG_Exit_Sum',
            align: 'center'
          },
          {
            title: '合计',
            dataIndex: 'Exit_Total',
            key: 'Exit_Total',
            align: 'center'
          },
        ]
      },
    ]
    const billDoctorColumns = [
      {
        title: '申请机构',
        dataIndex: 'APPLY_HOSPITAL_NAME',
        key: 'APPLY_HOSPITAL_NAME',
        ellipsis: true,
        width: this.props.billHospitalCode ? 0 : 260,
        align: 'center'
      },
      {
        title: this.props.selectBillDoctorName ? '月份' : '姓名',
        dataIndex: 'BILLING_DOCTOR',
        key: 'BILLING_DOCTOR',
        ellipsis: true,
        align: 'center'
      },
      {
        title: '动态心电',
        dataIndex: 'HOLTER_Sum',
        key: 'HOLTER_Sum',
        align: 'center'
      },
      {
        title: '动态血压',
        dataIndex: 'BP_Sum',
        key: 'BP_Sum',
        align: 'center'
      },
      {
        title: '静息心电',
        dataIndex: 'ECG_Sum',
        key: 'ECG_Sum',
        align: 'center'
      },
      {
        title: '合计',
        dataIndex: 'Total',
        key: 'Total',
        align: 'center'
      },
    ]

    return (
      <div className="truePaintPage">
        <div className='detaileView'
          ref={el => (this.lessThanTwentyPagesRef = el)}//小于18页用切割
          style={{
            width: 297 + 'mm',
            height: this.state.PageCount * 210 + 'mm',
            color: '#000',
            zoom: 1,
            overflow: 'hidden',
          }}>
          {
            GroupByPage && GroupByPage.length > 0 ? GroupByPage.map((item, key) => {
              return (
                <div
                  key={key + item}
                  ref={el => { this.moreThanTwentyPagesRef[key] = el }}//大于18页
                  style={{
                    padding: '5mm 7mm',
                    height:'210mm'
                  }}>

                  <div className='title'>
                    {
                      this.props.showKey === '1' ? '会诊量统计表' : this.props.showKey === '2' ? '医生工作量统计表' : '开单量统计表'
                    }
                  </div>
                  <Table
                    columns={this.props.showKey === '1' ? columns : this.props.showKey === '2' ? doctorColumns : billDoctorColumns}
                    dataSource={item}
                    bordered
                    pagination={false}
                    scroll={false}
                    size='small'
                    title={this.props.showKey === '1' ? () => (
                      <div className="tableHeader">
                        <p>会诊机构：{this.props.consultHospitalName}</p>
                        {this.props.applyHospitalName ?
                          <p>申请机构：{this.props.applyHospitalName}</p> : null
                        }
                        <p>查询年度：{this.props.selectStartValue} {this.props.selectConsultationMonth ? ' - ' + this.props.selectConsultationMonth : ''}</p>
                      </div>
                    ) : this.props.showKey === '2' ? () => (
                      <div className="tableHeader">
                        {this.props.selectdoctorName ?
                          <p>姓名：{this.props.selectdoctorName}</p> : null
                        }
                        <p>隶属机构：{this.props.consultHospitalName}</p>
                        <p>统计年度：{this.props.selectEndValue}{this.props.selectDoctorMonth ? ' - ' + this.props.selectDoctorMonth : ''}</p>
                      </div>
                    ) : () => (
                      <div className="tableHeader">
                        {this.props.selectBillDoctorName ?
                          <p>姓名：{this.props.selectBillDoctorName}</p> : null
                        }
                        <p>隶属机构：{this.props.billHospitalName}</p>
                        <p>统计年度：{this.props.selectEndValue}{this.props.selectBillMonth ? ' - ' + this.props.selectBillMonth : ''}</p>
                      </div>
                    )}
                  >

                  </Table>
                </div>
              )
            }) : <div
              ref={el => { this.moreThanTwentyPagesRef[0] = el }}//大于18页
              style={{
                padding: '2mm 1mm',
              }}>

              <div className='title'>
                {
                  this.props.showKey === '1' ? '会诊量统计' : this.props.showKey === '2' ? '医生工作量统计' : '开单量统计'
                }
              </div>
              <Table
                columns={this.props.showKey === '1' ? columns : this.props.showKey === '2' ? doctorColumns : billDoctorColumns}
                dataSource={[]}
                bordered
                pagination={false}
                scroll={false}
                size='small'
                title={this.props.showKey === '1' ? () => (
                  <div className="tableHeader">
                    <p>会诊机构：{this.props.consultHospitalName}</p>
                    {this.props.applyHospitalName ?
                      <p>申请机构：{this.props.applyHospitalName}</p> : null
                    }
                    <p>查询年度：{this.props.selectStartValue} {this.props.selectConsultationMonth ? ' - ' + this.props.selectConsultationMonth : ''}</p>
                  </div>
                ) : this.props.showKey === '2' ? () => (
                  <div className="tableHeader">
                    {this.props.selectdoctorName ?
                      <p>姓名：{this.props.selectdoctorName}</p> : null
                    }
                    <p>隶属机构：{this.props.consultHospitalName}</p>
                    <p>统计年度：{this.props.selectEndValue}{this.props.selectDoctorMonth ? ' - ' + this.props.selectDoctorMonth : ''}</p>
                  </div>
                ) : () => (
                  <div className="tableHeader">
                    {this.props.selectBillDoctorName ?
                      <p>姓名：{this.props.selectBillDoctorName}</p> : null
                    }
                    <p>隶属机构：{this.props.billHospitalName}</p>
                    <p>统计年度：{this.props.selectEndValue}{this.props.selectBillMonth ? ' - ' + this.props.selectBillMonth : ''}</p>
                  </div>
                )}
              >

              </Table>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default Form.create()(PaintStatisticsTable)
